import { addStyles } from 'ethcss'
import { IStyles } from 'theme'
import { color } from 'theme/tokens/color'

const header: IStyles = {
    header: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
    },
    buttons: {
        display: 'flex',
        alignItems: 'center',
    },
    search: {
        width: 'calc(100% - 130px)',
    },
    searchInput: {
        width: '100%',
        padding: '6px 10px',
        border: `1px solid ${color.borderDarkPrimary}`,
        borderRadius: 5,
        color: color.fontDarkUltraHigh,
        background: color.bgWhitePrimary,
    },
}

addStyles(header)
export default header
